import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "name", "value", "checked", "disabled"];
const _hoisted_2 = ["for"];
import { toRefs, watchEffect, ref } from 'vue';
export default {
  __name: 'AppgCheckBox',
  props: {
    id: {
      type: String,
      default: () => `id_${Math.random()}`
    },
    modelValue: {
      type: [Object, Number, Boolean, String, Array]
    },
    name: {
      type: String,
      default: 'checkbox'
    },
    value: {
      type: [Object, Number, Boolean, String, Array],
      default: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    _class: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'input'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const {
      id,
      modelValue,
      name,
      value,
      checked,
      label,
      _class
    } = toRefs(props);
    const cloneValue = ref();
    watchEffect(() => cloneValue.value = modelValue.value);
    watchEffect(() => {
      emits('update:modelValue', cloneValue.value);
      emits('input', cloneValue.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["form-check", _unref(_class)])
      }, [_withDirectives(_createElementVNode("input", {
        id: _unref(id),
        class: "form-check-input",
        type: "checkbox",
        name: _unref(name),
        value: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => cloneValue.value = $event),
        checked: _unref(checked),
        disabled: __props.disabled
      }, null, 8, _hoisted_1), [[_vModelCheckbox, cloneValue.value]]), _createElementVNode("label", {
        for: _unref(id),
        class: _normalizeClass(["form-check-label", _ctx.$attrs.class])
      }, [_renderSlot(_ctx.$slots, "default"), _createTextVNode(" " + _toDisplayString(_unref(label)), 1)], 10, _hoisted_2)], 2);
    };
  }
};